import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { EMPTY_ARRAY } from '@e-socna/empty';
import { geocodingSearchFetcher } from '@e-socna/gis';
import { isDefined } from '@e-socna/utils';
import type { GeocodingSearchIndex, GeocodingSearchParams } from '@e-socna/gis';

import { environment } from '../../../../environment';

export const useGeoCodingSearchQuery = <GSI extends GeocodingSearchIndex>(
  params: GeocodingSearchParams<GSI>,
) => {
  const { fetcher } = useMemo(
    () => geocodingSearchFetcher(params, environment.backendUrl),
    [params],
  );

  return useQuery({
    queryKey: [
      'useGeoCodingSearchQuery',
      params.q,
      ...(params.coordinates ?? EMPTY_ARRAY),
      params.index,
      params.limit,
      params.returntruegeometry,
    ],
    queryFn: fetcher,
    enabled: isDefined(params.enabled) ? params.enabled : true,
  });
};
